import ForgotPasswordSubmitForm from './ForgotPasswordSubmitForm';

export default ForgotPasswordSubmitForm;
